<template>
  <div class="p_export_list">
      <div class="topOperation">
            <div class="top-left">
                <ShowNavHead />
            </div>
            <div class="top-right">
                <el-button type="text" @click="dropDownScreen" style="margin-right:20px">
                <img src="../../assets/employee/images/screen.png" />
                <span>筛选</span>
                </el-button>
            </div>
            <!-- 筛选下拉框 -->
            <div class="dropDownScreen" v-show="showDropScreen==1">
                <div class="cus_drop_box">
                  <el-form :inline="true" :model="infoQuery" class="cus_drop_form" label-width="100px">
                    <el-form-item label="文件名称:">
                      <el-input size="small" v-model="infoQuery.custname" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="操作时间:">
                      <el-date-picker style="width:300px!important" clearable v-model="infoQuery.impdate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="drop-footer">
                <button class="clear" style="margin-right:10px" @click="resetHandle">清空</button>
                <button class="search" @click="searchHandle">搜索</button>
                <button class="clear" @click="showDropScreen=-1">关闭</button>
                </div>
            </div>
        </div>
    <div class="main-con">
    <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>客户</el-breadcrumb-item>
            <el-breadcrumb-item>客户列表</el-breadcrumb-item>
            <el-breadcrumb-item>导出记录</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="expRecordTable">
    <el-table :data="tableData"  :max-height="tableHeight-180" v-loading="listLoading" element-loading-text="导出记录生成中"
            element-loading-spinner="el-icon-loading">
        <!-- <el-table-column align="center" type="selection" width="50"></el-table-column> -->
        <el-table-column align="center" label="序号" width="50">
        <template slot-scope="{$index}">
            <span>{{(Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) + Number($index) + 1}}</span>
        </template>
        </el-table-column>
        <el-table-column align="center" label="文件名称" prop="StrOutCustName" min-width="23%">
        <template slot-scope="{row}">
            <span>{{row.StrOutCustName}}</span>
        </template>
        </el-table-column>
        <el-table-column align="center" label="格式" min-width="16%">
        <template>xlsx</template>
        </el-table-column>
        <el-table-column align="center" label="操作人员" prop="Username" width="100px"></el-table-column>
        <el-table-column align="center" label="操作时间" prop="DtImpDate" min-width="16%">
        <template slot-scope="{row}">
            <span>{{row.DtImpDate.replace(/T/, " ").substring(0,19)}}</span>
        </template>
        </el-table-column>
        <el-table-column align="center" label="状态" min-width="16%">
        <template slot-scope="scope">
            <span v-if="scope.row.path">已生成</span>
            <span v-if="isNull(scope.row.path)&&(new Date().getTime() < new Date((new Date(scope.row.DtImpDate.length>=19?scope.row.DtImpDate.substring(0,19):scope.row.DtImpDate)).valueOf() + (scope.row.StrOutCustName.indexOf('全员导出')==-1 ? 360000 : 1200000)).getTime())">
                <i class="el-icon-loading"></i>
                <span>正在生成中</span>
            </span>
            <span v-if="(new Date().getTime() > new Date((new Date(scope.row.DtImpDate.length>=19?scope.row.DtImpDate.substring(0,19):scope.row.DtImpDate)).valueOf() + (scope.row.StrOutCustName.indexOf('全员导出')==-1 ? 360000 : 1200000)).getTime())&&isNull(scope.row.path)">
                <span>导出失败</span>
            </span>
        </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="StrOperType" min-width="13%">
        <template slot-scope="scope">
            <a :href="scope.row.path" v-if="scope.row.path">下载</a>
        </template>
        </el-table-column>
    </el-table>
    <div class="block" v-show="totalcount>0 && qStstus==''">
        <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="infoQuery.currpage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="infoQuery.pagecount"
        layout="total,sizes,prev,pager,next,jumper"
        :total="totalcount"
        ></el-pagination>
    </div>
    </div>
    </div>
  </div>
</template>

<script>
import xz from './../../common.vue'
export default {
  name: 'cusExport',
  data() {
    return {
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight: 0,
      listLoading:false,
      totalcount: 0,
      // 下拉筛选
      showDropScreen:-1,
      tableData: [],
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        tableid: 'JB_base_Custout',
        custname: '',
        datestart: '',
        dateend: '',
        impdate:[]
      },
      // 定时器
      interval:null,
      custname:'',
      qStstus:''
    }
  },
  created(){
    this.calHeight()
    if (this.$route.query.isActive) {
      this.custname = this.$route.query.custname
      this.qStstus = this.$route.query.qStstus
    }
  },
  mounted(){
    // console.log('qStstus',this.qStstus)
    (this.qStstus) ? (this.timeOut()) : (this.getExportRecord(this.infoQuery))
  },
  methods: {
    calHeight(){
        this.tableHeight = Number(document.body.clientHeight)
        //  console.log('height',this.tableHeight) 
    },
    // 确保生成的一条数据是最新导出的
    timeOut(){
      this.listLoading = true
      setTimeout(()=>{this.getlastexp()}, 3000)
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    // 判断是否为空(包含0)
    isNull(o) {
        return o == undefined || o == 'undefined' || (o + '').indexOf('undefined') > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
    },
    // 翻页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.infoQuery.currpage = Number(val)
      this.getExportRecord(this.infoQuery)
    },
    handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.infoQuery.pagecount = Number(`${val}`)
        this.getExportRecord(this.infoQuery)
    },
    // 搜索
    searchHandle(){
        this.infoQuery.currpage = 1
        this.infoQuery.datestart = this.infoQuery.impdate[0]
        this.infoQuery.dateend = this.infoQuery.impdate[1]
        this.getExportRecord(this.infoQuery)
    },
    //清空
    resetHandle() {
      this.infoQuery = {
        pagecount: 10,
        currpage: 1,
        tableid: 'JB_base_Custout',
        custname: '',
        datestart: '',
        dateend: '',
        impdate:[]
      }
    },
    //获取最新一条导出记录
    async getlastexp(){
        clearInterval(this.interval)
        let custname = this.custname
        this.listLoading = true
        xz.getLastExpData(custname).then(res=>{
        //  console.log('res',res)
        this.tableData = []
        if(res && res!='没有记录！'){
            //  res.DtImpDate = res.DtImpDate.substring(0,10).replace(/-/, "/").replace(/-/, "/");
            this.tableData.push(res)
            if(res.StrOutPath){
            let d = res.StrOutPath
                d = d.replace("\"","").replace("\"","")
                let path = this.tablePath + d
                this.$set(this.tableData[0],"path",path)
                this.clear()
            }else{
            this.interval = setInterval(this.getlastexp, 10000)
            }
            this.listLoading = false
        }else{
            //清除定时器
            this.listLoading = true
            this.tableData = []
            this.interval = setInterval(this.getlastexp, 10000)
        }
        })
    },
    //导出记录历史
    getExportRecord(data){
      this.listLoading = true
      this.infoQuery = data
      xz.getExpRec(data).then(res=>{
        // console.log('历史',res)
        if(res.msg.length>0){
          res.msg.forEach(l => {
            //  l.DtImpDate = l.DtImpDate.substring(0,10).replace(/-/, "/").replace(/-/, "/");
            if(l.StrOutPath){
              let d = l.StrOutPath
              d = d.replace("\"","").replace("\"","")
              let path = this.tablePath + d
              this.$set(l,"path",path)
            }
          })
          this.tableData = res.msg
          this.totalcount = parseInt(res.totalcount)
        }else{
          this.tableData = []
          this.totalcount = 0
        }
        this.listLoading = false
      })
    },
    // 清除定时器的代码
    clear() {
        clearInterval(this.interval)
        this.interval = null
    }
  },
  beforeDestroy(){
    // 在页面销毁后，清除计时器
    this.clear()
  }
}
</script>

<style>
.p_export_list .formScreenInput .el-input__icon{
    margin-top: 0;
}
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}

.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
</style>